var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarnpoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "earn_points",
    "data-name": "earn points",
    transform: "translate(-2171.469 -929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1099",
    "data-name": "Ellipse 1099",
    transform: "translate(2171.469 929)",
    fill: "#fff",
    stroke: "#029c27",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "points",
    transform: "translate(2197.594 955.11)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1101",
    "data-name": "Ellipse 1101",
    cx: 17.18,
    cy: 6.608,
    rx: 17.18,
    ry: 6.608,
    transform: "translate(0.077 0.062)",
    fill: "#029c27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M14.736,17.616a18.964,18.964,0,0,1,5.754-7.065c-1.189.1-2.386.169-3.589.169C10.318,10.721,3.7,9.2,0,6.253v4.468C0,14.262,6.426,17.177,14.736,17.616Z",
    transform: "translate(0.013 6.178)",
    fill: "#029c27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M12.924,20.692a18.788,18.788,0,0,1,.722-5.112C8.21,15.162,3.084,13.709,0,11.253v4.468c0,3.293,5.557,6.043,13.016,6.766C12.96,21.9,12.924,21.3,12.924,20.692Z",
    transform: "translate(0.013 11.12)",
    fill: "#029c27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M23.907,8A15.907,15.907,0,1,0,39.814,23.907,15.925,15.925,0,0,0,23.907,8Zm-.756,14.416h1.511a4.22,4.22,0,0,1,.736,8.375v1.565a1.491,1.491,0,1,1-2.983,0V30.866H20.427a1.491,1.491,0,0,1,0-2.983h4.235a1.243,1.243,0,0,0,0-2.485H23.151a4.22,4.22,0,0,1-.736-8.375V15.456a1.491,1.491,0,1,1,2.983,0v1.491h1.988a1.491,1.491,0,0,1,0,2.983H23.151a1.243,1.243,0,0,0,0,2.485Z",
    transform: "translate(7.92 7.904)",
    fill: "#029c27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnpoints);
export default __webpack_public_path__ + "static/media/earn points.6c80fafba8ffeab0be23644956370535.svg";
export { ForwardRef as ReactComponent };